<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">客户案例</div>
          <div class="content">沐桦科技使用住宅IP代理，IP资源来自世界各地真实的家庭WIFI中的住宅IP，绝不会暴露您的真实位置和身份。各种客户使用沐桦科技的动态代理服务，进行零售价格比较、广告验证、品牌保护、网站压力测试、舆情监测等信息的获取。</div>
        </div>
      </div>
    </div>
    <section class="situation">
      <div class="muhua-title">客户使用场景</div>
      <div class="card-wrap">
        <div class="card-content">
          <div class="card">
            <img
              src="./../assets/custome/sale.png"
              class="border"
            >
            <div class="title">销售情报</div>
            <div class="little-title">了解谁是您服务的最佳目标客户</div>
          </div>
        </div>
        <div class="card-content">
          <div class="card">
            <img
              class="border"
              src="./../assets/custome/dun.png"
            >
            <div class="title">品牌保护</div>
            <div class="little-title">监控网络是否您的品牌被正确使用，以保护您的知识产权，商标和定价策略</div>
          </div>
        </div>
        <div class="card-content">
          <div class="card">
            <img
              src="./../assets/custome/ad.png"
              class="border"
            >
            <div class="title">广告验证</div>
            <div class="little-title">通过数百万个住宅动态IP验证广告的真实性。消除误导性广告和无效链接。</div>
          </div>
        </div>
      </div>
      <div class="card-wrap second-card-wrap">
        <div class="card-content">
          <div class="card">
            <img
              src="./../assets/custome/self.png"
              class="border"
            >
            <div class="title">自我检测</div>
            <div class="little-title">全球任意城市测试您的网站性能</div>
          </div>
        </div>
        <div class="card-content">
          <div class="card">
            <img
              class="border"
              src="./../assets/custome/people.png"
            >
            <div class="title">人才资源</div>
            <div class="little-title">帮助求职者和雇主更快更有效地联系</div>
          </div>
        </div>
        <div class="card-content">
          <div class="card">
            <img
              src="./../assets/custome/info.png"
              class="border"
            >
            <div class="title">比较情报</div>
            <div class="little-title">收集定价信息，不被屏蔽或误导</div>
          </div>
        </div>
      </div>
    </section>
    <section class="product-detail height-220">
      <div class="muhua-title advantage-title">了解如何使用沐桦动态代理网络服务</div>
      <div class="detail-wrap">
        <router-link to="/useDoc" class="button compute">
        查看产品文档
        </router-link>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import Header from "@/components/Header.vue";

export default {
  name: "home",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      activeIndex: "2-2-3"
    };
  },
  computed: mapState({}),
  created() {},
  methods: {
    ...mapActions([""])
  }
};
</script>

<style scoped lang="stylus">
.situation {
  background: rgba(248, 252, 255, 1);

  .card-wrap {
    width: 80%;
    max-width: 1200px;
    display: flex;
    margin: 0 auto;

    .card-content {
      width: 33%;
    }

    .card {
      min-height: 250px;
      text-align: center;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.06);
      border-radius: 2px;
      width: 230px;
      margin: 0 auto;

      img {
        width: 66px;
        height: 66px;
        margin: 18px 0 14px;
      }

      .title {
        font-size: 11px;
        font-weight: 400;
        color: rgba(63, 79, 124, 1);
        line-height: 20px;
        margin: 14px 0 7px;
      }

      .little-title {
        font-size: 9px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(116, 133, 152, 1);
        line-height: 23px;
        padding: 7px 19px 34px;
      }
    }
  }

  .second-card-wrap {
    margin-top: 34px;
    padding-bottom: 45px;
  }
}

.banner {
  background: #282A3C;
  width: 100%;
  height: 360px;
  display: flex;
  background: url('./../assets/custome/banner.png');
  background-size: cover;

  .banner-content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    max-width: 1200px;
  }

  .left-banner {
    width: 59%;

    .title {
      font-size: 38px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 64px;
      margin: 77px 0 14px 0;
    }

    .content {
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 23px;
      margin-bottom: 27px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 32px;
    }

    .know-more {
      width: 96px;
      height: 31px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(40, 42, 60, 1);
      line-height: 20px;
      text-align: center;
      line-height: 31px;
    }
  }

  .right-banner {
    width: 41%;
  }
}

.advantage-wrap {
  background: rgba(255, 255, 255, 1);

  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;

    .card-wrap {
      width: 25%;

      .card {
        margin: 0 auto;
        text-align: center;
      }

      img {
        width: 101px;
        height: 101px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(207, 223, 244, 1);
        margin-botton: 14px;
        border-color: #888;
        border-style: dashed;
      }

      .card-title {
        font-size: 11px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(63, 79, 124, 1);
        line-height: 20px;
        margin: 14px 0 68px;
      }
    }
  }
}

.application-warp {
  background: rgba(248, 252, 255, 1);

  .card-content {
    display: flex;
    width: 80%;
    margin: 0 auto;
    max-width: 1200px;

    .card-wrap {
      width: 33%;

      .card {
        margin: 0 auto;
        text-align: center;

        img {
          width: 56px;
          height: 46px;
        }

        .help-title {
          font-size: 11px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(63, 79, 124, 1);
          line-height: 20px;
        }

        .help-content {
          font-size: 9px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(116, 133, 152, 1);
          line-height: 16px;
          max-width: 130px;
          margin: 9px auto 84px;
        }

        .button {
          width: 93px;
          height: 27px;
          background: rgba(0, 174, 239, 1);
          border-radius: 2px;
          border: 1px solid rgba(0, 174, 239, 1);
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 12px;
        }
      }
    }
  }
}

.product-detail {
  background-image: url('../assets/background/white_point.png');
  background-size: cover;

  .detail-wrap {
    display: flex;
    justify-content: center;
  }
}
</style>
